import Vue from 'vue'
import AppVue from './App.vue'
import App from './application.js'
import router from './routes.js' // added by router plugin

Vue.config.productionTip = false

// Filters
Vue.filter('truncate', function (value) {
    return value.toString().substring(0, 4);
});

// Settings
var configElement = document.getElementById('unexapp_settings');
var config = {
    apiUrl: null
};

if (configElement) {
    config = JSON.parse(configElement.innerHTML);
    //console.log('config: ', config);
}

// ApiURL
if (config.apiUrl) {
    App.apiUrl = config.apiUrl;
    console.log("Setting apiURL: " + config.apiUrl)
}

// Mount global variable
if (!window.Unex) window.Unex = {}
window.Unex.UnexApp = App


// Init App
await App.init()


// Utils
String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
};

const vueApp = new Vue({
    el: '#app',
    router: router,
    render: h => h(AppVue),
})
